import { buildLoader } from '../util/GenericLoader';
import fetchAllTagsActionCreator from '../../redux/actions/tags';

export default buildLoader(fetchAllTagsActionCreator);
